import { render, staticRenderFns } from "./hoehetbegon.vue?vue&type=template&id=3497d540&scoped=true"
import script from "./hoehetbegon.vue?vue&type=script&lang=js"
export * from "./hoehetbegon.vue?vue&type=script&lang=js"
import style0 from "./hoehetbegon.vue?vue&type=style&index=0&id=3497d540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3497d540",
  null
  
)

export default component.exports